import React, { Component } from 'react';
import { compose } from 'recompose';
import Address from './Address';
import { withValidateShippingAddress } from '../Checkout/ShippingAndPayment/ValidateShippingAddress';
import ShippingAddressForm from '../Checkout/ShippingAndPayment/ShippingAddressForm';
import { connectUserDetail } from '../Auth/UserDetailManager';
import { WithMethods } from './AddressApi';
import StateStore from '../Common/StateStore';
import { undecorated as MessageContent } from '../Common/Modal/MessageContent';
import Modal from '../Common/Modal';
import { HTMLTrans } from '../Common/Translations';

const EDIT_ADDRESS_FORM = 'edit-address-form';
const NEW_ADDRESS_FORM = 'new-address-form';

class AddressBook extends Component {
  constructor(props) {
    super(props);
    this.renderAddress = this.renderAddress.bind(this);
    this.deleteAddress = this.deleteAddress.bind(this);
    this.saveEditAddress = this.saveEditAddress.bind(this);
    this.saveNewAddress = this.saveNewAddress.bind(this);
    this.cancelHandler = this.cancelHandler.bind(this);
    this.updateState = this.updateState.bind(this);
  }

  state = {
    isLoaded: false,
    data: [],
    editId: -1,
    areAddressDetailsValid: true,
    suggestedPostalCodeCombination: null,
    addressValidationErrors: null
  };

  getMethods() {
    const methods = ({
      updateState,
    }) => ({
      updateState,
    });
    return methods(this);
  }

  updateState(state) {
    this.setState({ ...state });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.editId === -1 && this.state.editId > -1) {
      $('html, body').animate({ scrollTop: $(`#${EDIT_ADDRESS_FORM}`).offset().top - 100 }, 1000);
    }
    if (!prevState.addNewAddress && this.state.addNewAddress) {
      $('html, body').animate({ scrollTop: $(`#${NEW_ADDRESS_FORM}`).offset().top - 100 }, 1000);
    }
  }

  deleteAddress(address) {
    this.props.deleteAddress(address).done(() => {
      this.setState((prevState) => {
        const index = prevState.data.findIndex(item => (item.id === address.id));
        return {
          editId: -1,
          deleteAddress: false,
          data: [
            ...prevState.data.slice(0, index),
            ...prevState.data.slice(index + 1)
          ]
        };
      });
    }).fail(() => {alert(this.props.t("account.addressbook_delete_fail", "delete failed"))});
  }

  cancelHandler() {
    this.setState({
      editId: -1
    });
  }

  componentDidMount() {
    this.shouldCallApi = window.location.pathname.includes('address');
    this.didCallApi = false;
  }

  componentDidUpdate() {
    this.shouldCallApi = window.location.pathname.includes('address');
    if(this.shouldCallApi && !this.didCallApi) {
      this.didCallApi = true;
      this.props.getAddress().done((response) => {
        this.setState({
          isLoaded: true,
          data: response.data
        });
      }).fail(
        response => alert(`${this.props.t("account.addressbook_getaddress_fail", "Get address failed")} ${response.status}`));
    }
  }

  chunkBySize(array = [], chunk) {
    // it chunks array into array with sized elements
    return array.reduce((ar, it, i) => {
      const ix = Math.floor(i/chunk);
      if (!ar[ix]) {
        ar[ix] = [];
      }
      ar[ix].push(it);
      return ar;
    }, []);
  }

  clearDefaultFlag(addresses) {
    return addresses.map((item) => {
      item.is_default_shipping = false;
      return item;
    });
  }

  saveEditAddress(address) {
    this.props.saveEditAddress(address).done((response) => {
      const { data } = response;
      this.setState((prevState) => {
        const index = prevState.data.findIndex(item => (item.id === data.id));
        let addresses = prevState.data;
        if (data.is_default_shipping) {
          addresses = this.clearDefaultFlag(addresses);
        }
        return {
          editId: -1,
          data: [
            ...addresses.slice(0, index),
            data,
            ...addresses.slice(index + 1)
          ]
        };
      });
    });
  }

  saveNewAddress(address) {
    this.props.saveNewAddress({
      ...address,
      is_default_billing: false
    }).done((response) => {
      const { data } = response;
      this.setState((prevState) => {
        let addresses = prevState.data;
        if (data.is_default_shipping) {
          addresses = this.clearDefaultFlag(addresses);
        }
        addresses.push(data);
        return {
          data: addresses,
          addNewAddress: false,
          addDefaultAddress: false
        };
      });
    });
  }

  renderShippingForm(props) {
    const {
      address,
      onSave,
      onCancel,
      is_default_shipping = false,
    } = props;
    return (
      <StateStore state={{ is_default_shipping }}>
        {(localState, localSetState) => (
          <ShippingAddressForm
            id={this.state.editId === -1 ? 'newAddress' : 'editAddress'}
            showPhoneField
            address={address}
            onSave={(address) => {
              onSave({
                ...address,
                ...localState
              })
            }}
            onCancel={onCancel}
            areAddressDetailsValid={this.state.areAddressDetailsValid}
            methods={this.getMethods()}
            suggestedPostalCodeCombination={this.state.suggestedPostalCodeCombination}
            addressValidationErrors={this.state.addressValidationErrors}
          >
            <div className="container row">
              <div className='col-lg-4'/>
              <div className='col ml-md-1'>
                <label className="custom-control custom-checkbox">
                  <input
                    className="custom-control-input mr-1"
                    checked={localState.is_default_shipping}
                    onChange={() => {
                      localSetState({
                        is_default_shipping: !localState.is_default_shipping
                      });
                    }}
                    type="checkbox"/>
                    <span className="custom-control-indicator"></span>
                    <span className="custom-control-description">
                      <HTMLTrans id="account.addressbook_cbx_msg">Save as default address</HTMLTrans>
                    </span>
                </label>
              </div>
            </div>
          </ShippingAddressForm>
        )}
      </StateStore>
    );
  }

  renderAddress(address, index) {
    const str = Object.values(address).join(' ');
    const disabled = (this.state.editId > -1) && this.state.editId !== address.id;
    const hide = (this.state.editId > -1) && this.state.editId === address.id;
    return (
      <div key={str} className='row col-lg-6 mb-3'>
      {`${index + 1}.`}<span>&nbsp;</span>
      <Address
        {...this.props}
        {...address}
        disabled={disabled}
        hide={hide}
        onEdit={async () => {
          let addressValidation = await this.props.validateShippingAddress(address);
          this.setState({
            editId: address.id,
            areAddressDetailsValid: addressValidation.success,
            suggestedPostalCodeCombination: !addressValidation.success ? addressValidation.data : null,
            addressValidationErrors: !addressValidation.success ? addressValidation.errors : null
          });
        }}
        onDelete={() => {
          this.setState({ deleteAddress: address });
          // this.deleteAddress(address);
        }}
        onMakeDefault={() => { this.saveEditAddress({
          ...address,
          is_default_shipping: true
        }); }}
      />
      </div>
    );
  }

  renderDefaultAddress(address, index) {
    let items = [];
    items.push(this.renderAddress(address, 0));
    if (address.id === this.state.editId) {
      items.push(
        <div id={EDIT_ADDRESS_FORM} key={`editForm-${index}`}
         className='col-12 order-lg-12'>
          <ShippingAddressForm
            showPhoneField
            address={{
              ...address,
              is_default_shipping: true
            }}
            onSave={this.saveEditAddress}
            onCancel={this.cancelHandler}
            areAddressDetailsValid={this.state.areAddressDetailsValid}
            methods={this.getMethods()}
            suggestedPostalCodeCombination={this.state.suggestedPostalCodeCombination}
            addressValidationErrors={this.state.addressValidationErrors}
          />
        </div>
      );
    }
    return items;
  }

  render() {
    const {
      addNewAddress = false,
      addDefaultAddress = false
    } = this.state;
    const defaultAddress = this.state.data.find((item) => {
      return item.is_default_shipping;
    });
    let numbering = 0;
    let otherAddresses = [];
    const nonDefaultAddresses = this.state.data.filter(item => !item.is_default_shipping);
    const pairs = this.chunkBySize(nonDefaultAddresses, 2);
    otherAddresses = pairs.map((pair, index) => {
      let row = [];
      pair.map((address, innerIndex) => {
        row.push(this.renderAddress(address, innerIndex + numbering));
        if (address.id === this.state.editId) {
          row.push(
            <div id={EDIT_ADDRESS_FORM} key={`editForm-${innerIndex + numbering}`}
             className='col-12 order-lg-12'>
             {this.renderShippingForm({
               address,
               onSave: this.saveEditAddress,
               onCancel: this.cancelHandler
             })}
            </div>
          );
        }
      });
      numbering += pair.length;
      return <div key={`row-${index}`} className='row col-12'>{row}</div>;
    });
    if (!this.state.isLoaded) {
      return null;
    }
    return (
      <div className='dashboard-card'>
        <h3><HTMLTrans id="account.addressbook_title_h3">Address Book</HTMLTrans></h3>
        <hr className='bg-gray'/>
        <div className='d-flex flex-column flex-lg-row justify-content-between' >
          {!defaultAddress &&
            <a
              onClick={(e) => { e.preventDefault(); this.setState({ addDefaultAddress: true }); }}
              className='btn btn-sm btn-link align-self-end align-self-lg-baseline order-lg-2'>
              <u><HTMLTrans id="account.addressbook_add_default_link">+ ADD DEFAULT ADDRESS</HTMLTrans></u>
            </a>
          }
          <h4 className='ProximaNova-Bold order-lg-1'><HTMLTrans id="account.addressbook_title_default">Default Shipping Address</HTMLTrans></h4>
        </div>
        <div className='row'>
          <div className='col-10'>
            {!defaultAddress && <p><HTMLTrans id="account.addressbook_no_default">You don’t have default address yet. Add default address now.</HTMLTrans></p>}
            {defaultAddress && this.renderDefaultAddress(defaultAddress, 0)}
          </div>
          { addDefaultAddress &&
              <ShippingAddressForm
                showPhoneField
                address={{ is_default_shipping: true }}
                onSave={this.saveNewAddress}
                onCancel={this.setState.bind(this,
                  { addDefaultAddress: false }
                )}
                areAddressDetailsValid={this.state.areAddressDetailsValid}
                methods={this.getMethods()}
                suggestedPostalCodeCombination={this.state.suggestedPostalCodeCombination}
                addressValidationErrors={this.state.addressValidationErrors}
              />
          }
        </div>
        { (otherAddresses.length > 0 || defaultAddress)
          && <div>
          <hr className='bg-gray-lighten-2'/>
          <div className='d-flex flex-column flex-lg-row justify-content-between' >
            <a
              onClick={() => {
                this.setState({
                  addNewAddress: true,
                  areAddressDetailsValid: true,
                  suggestedPostalCodeCombination: null,
                  addressValidationErrors: null
                });
              }}
              className='text-primary btn btn-sm btn-link align-self-end align-self-lg-baseline order-lg-2'>
              <u><HTMLTrans id="account.addressbook_add_new_link">+ ADD NEW ADDRESS</HTMLTrans></u>
            </a>
            <h4 className='ProximaNova-Bold order-lg-1'><HTMLTrans id="account.addressbook_title_additional">Additional Shipping Address</HTMLTrans></h4>
          </div>
          <div className='container'>
            {addNewAddress &&
              <div id={NEW_ADDRESS_FORM}>
                {
                  this.renderShippingForm({
                    onSave: this.saveNewAddress,
                    onCancel: () => { this.setState({ addNewAddress: false }); }
                  })
                }
            </div>
            }
            <div className='row'>
              {otherAddresses}
              {otherAddresses.length < 1
                && <div><HTMLTrans id="account.addressbook_no_additional">You don’t have any additional address yet.</HTMLTrans></div>
              }
            </div>
          </div>
        </div>
        }
        <Modal modalId='message-modal'
          style={{}}
          onClose={() =>  this.setState({ deleteAddress: false}) }
          open={(this.state.deleteAddress)}
          >
          {closeModal => (
            <MessageContent
              closeModal={closeModal}
              message={{
                title: this.props.t("account.addressbook_del_title", "Delete Address"),
                status: 'info',
                errorMessage: this.props.t("account.addressbook_del_error", "Are you sure to delete the address ?")
              }}>
                <div className='modal-footer d-flex justify-content-center'>
                  <button
                    className='btn btn-outline-primary'
                    onClick={() => {
                      closeModal();
                      this.setState({ deleteAddress: false });
                    }}><HTMLTrans id="account.addressbook_cancel_button">Cancel</HTMLTrans></button>
                  <button
                    className='btn btn-primary px-5'
                    onClick={() => {
                      this.deleteAddress(this.state.deleteAddress);
                    }}
                  >
                  <HTMLTrans id="account.addressbook_yes_button">Yes</HTMLTrans>
                </button>
                </div>
              </MessageContent>
          )}
        </Modal>
      </div>
    );
  }
}

const enhance = compose(
  WithMethods,
  connectUserDetail,
  withValidateShippingAddress
)

export const undecorated = AddressBook;
export default enhance(AddressBook);



// WEBPACK FOOTER //
// ./src/Address/AddressBook.js